import { call, put, select  } from 'redux-saga/effects';
import { push } from 'react-router-redux';

/*
Estos efectos - que importamos de redux-saga/effects - son handlers que nos permiten interactuar fácilmente con nuestro código redux:

put() - hace disptach una acción de nuestra saga.
take() - detiene nuestra saga hasta que una acción sucede en nuestra aplicación.
select() - obtiene una parte del estado redux (como mapStateToProps).
call() - llama a la función pasada como el primer argumento con los argumentos restantes.
*/

import { 
  loginAsync, 
  getIsAuthAsync, 
  logoutAsync,

  verifyMfaAsync  
} from '../services/authServices';

import {
  loginSuccess, 
  loginError, 
  getIsAuthSuccess, 
  getIsAuthError,
  logoutSuccess, 
  setLoading,

  mfaRequired, 
  mfaClear, 
  mfaVerifyError,
} from '../actions/authActions';

// Helper: agarra el primer valor "usable"
const pick = (...vals) => vals.find(v => v !== undefined && v !== null && v !== '');

const normalizeMfaType = (v) => {
  if (!v) return 'TOTP';
  const s = String(v).trim().toUpperCase();
  if (s === '1') return 'TOTP';
  if (s === '2') return 'EMAIL';
  if (s === 'TOTP') return 'TOTP';
  if (s === 'EMAIL') return 'EMAIL';
  return s;
};

export function* login({ payload: { user } }) {
  yield put(setLoading(true));
  try {
    const res = yield call(loginAsync, user);
    // Si requiere MFA
    if (res?.mfaRequired === true) {
      const mfaToken = pick(res?.mfaToken, res?.token, res?.ticket);
      const mfaType = normalizeMfaType(pick(res?.mfaType, res?.type));
      const emailMasked = res?.emailMasked || null;
      const canLogin = !!res?.canLogin;

      if (!mfaToken) {
        throw { status: 500, code: 'MFA_TOKEN_MISSING', message: 'El backend indicó MFA pero no devolvió el ticket.' };
      }

      // opcional: persistir el ticket por si refrescan
      yield call([sessionStorage, 'setItem'], 'pimsMfa', JSON.stringify({
        mfaToken,
        mfaType,
        emailMasked,
        canLogin,
      }));

      // Actualiza store: esto evita que MfaScreen te devuelva a /login
      yield put(mfaRequired({
        mfaToken,
        mfaType,
        emailMasked,
        canLogin,
      }));

      return; // Queda esperando MFA
    }

    // Aca es la primera vez que se que es admin...
    yield call([localStorage, 'setItem'], 'pimsWebAdmin', (res.token));

    const authResult = {
      authenticated: true,
      canLogin: !!res?.canLogin,
    };

    yield put(loginSuccess(authResult));
    // yield put(push('/'));  ABCD
  } catch (err) {
    console.log(err);
    yield put(loginError(err));
  } finally {
    yield put(setLoading(false));
  }
}

// ================================= MFA verify saga =========================================
export function* verifyMfa({ payload }) {
  yield put(setLoading(true));
  try {
    const code = (payload?.code || '').replace(/\s/g, '');

    const mfaFromStore = yield select((state) => state.auth?.mfa);
    let ticket = mfaFromStore?.token;

    if (!ticket) {
      const raw = sessionStorage.getItem('pimsMfa');
      const parsed = raw ? JSON.parse(raw) : null;
      ticket = parsed?.mfaToken || parsed?.token || parsed?.ticket;
    }

    if (!ticket) {
      yield put(mfaClear());
      yield call([sessionStorage, 'removeItem'], 'pimsMfa');
      throw { status: 401, code: 'MFA_MISSING', message: 'Sesión MFA inválida. Volvé a iniciar sesión.' };
    }
    const res = yield call(verifyMfaAsync, { token: ticket, code });

    const jwt = pick(res?.token, res?.jwt, res?.accessToken);
    if (!jwt) {
      throw { status: 500, code: 'MFA_NO_JWT', message: 'MFA OK pero el backend no devolvió el JWT.' };
    }

    yield call([localStorage, 'setItem'], 'pimsWebAdmin', jwt);

    yield put(mfaClear());
    yield call([sessionStorage, 'removeItem'], 'pimsMfa');

    const canLogin = !!res?.canLogin || !!mfaFromStore?.canLogin;

    yield put(loginSuccess({
      authenticated: true,
      canLogin,
    }));

  } catch (err) {
    yield put(mfaVerifyError(err));
  } finally {
    yield put(setLoading(false));
  }
}
// ================================= End MFA verify saga =========================================

export function* getIsAuth() {
  yield put(setLoading(true));
  try {
    const fromStorage = localStorage.getItem('pimsWebAdmin');
    //console.log('fromStorage: ', fromStorage);
    // const fromStorage = yield call([localStorage, 'getItem'], 'pimsWebAdmin');
    if (fromStorage !== null) {
      // Retorna bool..
      const authResult = { authenticated: false };
      // TODO REVISAR ESTO !!
      authResult.authenticated = yield call(getIsAuthAsync);
      console.log('authResult: ', authResult);
      if (authResult.authenticated) {
        console.log('call getIsAuthSuccess', authResult);
        yield put(getIsAuthSuccess(authResult));
        // yield put(push('/'));
      } else {
        yield put(getIsAuthError());
        yield call([localStorage, 'removeItem'], 'pimsWebAdmin');
      }
    } else yield put(getIsAuthError());
  } catch (err) {
    yield put(getIsAuthError());
    yield call([localStorage, 'removeItem'], 'pimsWebAdmin');
  } finally {
    yield put(setLoading(false));
  }
}

export function* logout() {
  yield put(setLoading(true));
  try {
    yield call(logoutAsync);
    yield call([localStorage, 'removeItem'], 'pimsWebAdmin');
    yield call([sessionStorage, 'removeItem'], 'pimsMfa'); 
    yield put(logoutSuccess());
  } catch (err) {
    console.error(err);
  } finally {
    yield put(setLoading(false));
  }
}
